module.exports = "<entity-card-collection\n  #albumCollection\n  [nPerRow]=\"4\"\n  [title]=\"'<h1 class=\\'left fade-in-1-sec\\'>Albums</h1>'\"\n  [titleUseHtml]=\"true\"\n  [noEntitiesMessage]=\"'No albums in library'\"\n  [showAllBtHoverText]=\"'Show all albums'\"\n  [albums]=\"albums\"\n  [showAll]=\"true\"\n  [libraryContextMenu]=\"true\"\n  [playFromCard]=\"true\"\n  [typeOfContent]=\"'albums'\"\n></entity-card-collection>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/content/library/albums/albums.component.html
// module id = ./src/app/components/dashboard/content/library/albums/albums.component.html
// module chunks = main